import { setUserInfo } from "@actions/profile.js";
import { showAlert } from "@components/alert/action";
import Loading from "@components/loading/index.jsx";
import { MainContext } from "@context";
import BonusesV2 from "@pages/profile-v2/pages/bonuses/index.js";
import Cashback from "@pages/profile-v2/pages/cashback/index.js";
import Deposit from "@pages/profile-v2/pages/deposit/index.js";
import HistoryV2 from "@pages/profile-v2/pages/history-v2/index.js";
import ProfilePage from "@pages/profile-v2/pages/profile/ProfilePage.js";
import Withdraw from "@pages/profile-v2/pages/withdraw/index.js";
import Inbox from "@pages/profile/inbox.jsx";
import { Inbox as BettoInbox } from "./betto/pages/Inbox";
import React, { useContext, useEffect, useState } from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import CloseIcon from "./assets/icons/CloseIcon.jsx";
import {
	BettoContentWrapper,
	BettoProfilePage,
	BettoProfileShell,
	BettoWalletContentWrapper,
	BettoWithdrawWarning,
} from "./betto";
import { BettoProfilePageWrapper } from "./betto/bettoProfileOverrides";
import { PersonalVerificationSection } from "./betto/pages/BettoProfilePage/sections/PersonalVerificationSection";
import SidebarMenu from "./components/SidebarMenu";
import {
	Page,
	PageContent,
	PageContentWrapper,
	PageHeader,
	PageWithSidebar,
	PageWrapper,
	WithdrawWarning,
} from "./elements.js";
import AccountInsights from "./pages/account-insights/index.js";
import Documents from "./pages/documents";
import Limits from "./pages/limits/index.js";
import DropdownMenu from "./pages/profile/components/DropdownMenu/index.js";

const getProfileRoutePath = (pathname) => {
	if (!pathname) {
		return "";
	}

	const normalized = pathname.split("?")[0].replace(/\/$/, "");

	return normalized || "/";
};

const ProfilePageV2 = ({ user, inbox, setUserInfo, showAlert, location, history, match }) => {
	const { isMobile, isTablet, isDesktop, isWide, isUltraWide } = useContext(MainContext).state;

	const [loading, setLoading] = useState(false);
	const profilePath = getProfileRoutePath(location?.pathname);

	const toggleLoading = () => {
		setLoading(!loading);
	};

	//TODO: updateUserInfo is not used in the component, it should be used or removed
	const updateUserInfo = (username, payload) => {
		setUserInfo(username, payload, () => {
			setLoading(false);
		});
	};

	useEffect(() => {
		const wrapperMain = document.querySelector("#WrapperMain");
		if (wrapperMain) {
			wrapperMain.classList.add("profile-page");
		}
	}, []);

	useEffect(() => {
		if (window.TENANT === "betto") {
			if (
				profilePath === "/profile/deposit" &&
				location?.search?.includes("openMethod=PromotionalCode")
			) {
				history.replace("/profile/promo-code");
				return;
			}
		}

		if (
			profilePath === "/profile/account-insights" &&
			window.PROFILE_INSIGHTS_MODULE === false
		) {
			history.replace("/profile/settings");
			return;
		}

		if (
			profilePath === "/profile/limits" &&
			(!Array.isArray(window.PROFILE_LIMITS_MODULE) || !window.PROFILE_LIMITS_MODULE.length)
		) {
			history.replace("/profile/settings");
		}
	}, [profilePath, location?.search, history]);

	const renderContents = (path, translate) => {
		const isBetto = window.TENANT === "betto";

		switch (path) {
			case "/profile/settings":
				return isBetto ? (
					<BettoProfilePage
						translate={translate}
						toggleLoading={toggleLoading}
						user={user}
						showAlert={showAlert}
						history={history}
						location={location}
					/>
				) : (
					<ProfilePage
						translate={translate}
						toggleLoading={toggleLoading}
						updateUserInfo={updateUserInfo}
						user={user}
						showAlert={showAlert}
					/>
				);
			case "/profile/inbox":
				return inbox ? (
					isBetto ? (
						<BettoContentWrapper>
							<BettoInbox location={location} />
						</BettoContentWrapper>
					) : (
						<Inbox location={location} />
					)
				) : null;
			case "/profile/documents":
				return isBetto ? (
					<BettoContentWrapper>
						<PersonalVerificationSection translate={translate} />
					</BettoContentWrapper>
				) : (
					<Documents translate={translate} />
				);
			case "/profile/history":
				return isBetto ? (
					<BettoContentWrapper>
						<HistoryV2 />
					</BettoContentWrapper>
				) : (
					<HistoryV2 />
				);
			case "/profile/bonuses":
				return isBetto ? (
					<BettoContentWrapper>
						<BonusesV2 />
					</BettoContentWrapper>
				) : (
					<BonusesV2 />
				);
			case "/profile/cashback":
				return isBetto ? (
					<BettoContentWrapper>
						<Cashback />
					</BettoContentWrapper>
				) : (
					<Cashback />
				);
			case "/profile/promo-code":
				return isBetto ? (
					<BettoContentWrapper>
						<Deposit
							history={history}
							location={{
								...location,
								search: "?openMethod=PromotionalCode",
							}}
							match={match}
							bettoReturnToProfile
						/>
					</BettoContentWrapper>
				) : (
					<Deposit
						history={history}
						location={{
							...location,
							search: "?openMethod=PromotionalCode",
						}}
						match={match}
					/>
				);
			case "/profile/deposit":
				return isBetto ? (
					<BettoWalletContentWrapper>
						<Deposit
							location={location}
							history={history}
							match={match}
						/>
					</BettoWalletContentWrapper>
				) : (
					<Deposit
						location={location}
						history={history}
						match={match}
					/>
				);
			case "/profile/withdraw":
				return isBetto ? (
					<BettoWalletContentWrapper>
						<Withdraw
							location={location}
							history={history}
							match={match}
						/>
					</BettoWalletContentWrapper>
				) : (
					<Withdraw
						location={location}
						history={history}
						match={match}
					/>
				);
			case "/profile/account-insights":
				return window.PROFILE_INSIGHTS_MODULE !== false ? <AccountInsights /> : null;
			case "/profile/limits":
				return Array.isArray(window.PROFILE_LIMITS_MODULE) &&
					window.PROFILE_LIMITS_MODULE.length ? (
					<Limits />
				) : null;
			default:
				return isBetto ? (
					<BettoProfilePage
						translate={translate}
						toggleLoading={toggleLoading}
						user={user}
						showAlert={showAlert}
						history={history}
						location={location}
					/>
				) : (
					<ProfilePage
						translate={translate}
						toggleLoading={toggleLoading}
						updateUserInfo={updateUserInfo}
						user={user}
						showAlert={showAlert}
					/>
				);
		}
	};
	return (
		<Translate>
			{({ translate }) => {
				const isBetto = window.TENANT === "betto";

				if (isBetto) {
					return (
						<BettoProfilePageWrapper
							as={PageWrapper}
							isColorful={window.IS_BOARD_WRAPPER_COLORFUL}>
							<BettoProfileShell
								translate={translate}
								currentPath={profilePath}
								history={history}>
								{renderContents(profilePath, translate)}
							</BettoProfileShell>
							{profilePath === "/profile/withdraw" && (
								<BettoWithdrawWarning>
									{translate(window.WITHDRAW_WARNING)}
								</BettoWithdrawWarning>
							)}
						</BettoProfilePageWrapper>
					);
				}

				return (
					<PageWrapper isColorful={window.IS_BOARD_WRAPPER_COLORFUL}>
						{loading && <Loading loading={loading} />}
						<PageWithSidebar>
							{(isWide || isUltraWide) && (
								<SidebarMenu
									isWithdrawOrDepositPage={
										profilePath === "/profile/deposit" ||
										profilePath === "/profile/withdraw"
									}
								/>
							)}
							<Page>
								<PageHeader>
									{(isDesktop || isMobile || isTablet) &&
										(window.TENANT === "rollblock" &&
										(profilePath === "/profile/deposit" ||
											profilePath === "/profile/withdraw") ? (
											<WalletTabs>
												<WalletTabsTitle>
													{translate("WALLET")}
												</WalletTabsTitle>
												<WalletTabsRow>
													<WalletTab
														active={profilePath === "/profile/deposit"}
														onClick={() =>
															history.push("/profile/deposit")
														}>
														<img
															src={arrowIcon}
															width="20"
															height="20"
															alt=""
															className="wallet-tab-arrow wallet-tab-arrow--deposit"
														/>
														{translate("DEPOSIT")}
													</WalletTab>
													<WalletTab
														active={profilePath === "/profile/withdraw"}
														onClick={() =>
															history.push("/profile/withdraw")
														}>
														<img
															src={arrowIcon}
															width="20"
															height="20"
															alt=""
															className="wallet-tab-arrow wallet-tab-arrow--withdraw"
														/>
														{translate("WITHDRAW")}
													</WalletTab>
												</WalletTabsRow>
											</WalletTabs>
										) : (
											<DropdownMenu
												translate={translate}
												location={location}
											/>
										))}
									<Link
										to="/"
										data-testid={
											profilePath === "/profile/deposit" ||
											profilePath === "/profile/withdraw"
												? "button-deposit-close"
												: "button-profile-close"
										}>
										<CloseIcon />
									</Link>
								</PageHeader>
								{profilePath === "/profile/withdraw" && (
									<WithdrawWarning>
										{translate(window.WITHDRAW_WARNING)}
									</WithdrawWarning>
								)}
								<PageContentWrapper>
									<PageContent>
										{renderContents(profilePath, translate)}
									</PageContent>
									<div id="navigation-btns"></div>
								</PageContentWrapper>
							</Page>
						</PageWithSidebar>
					</PageWrapper>
				);
			}}
		</Translate>
	);
};

const mapStateToProps = (state) => ({
	user: state.profile.user,
	inbox: state.profile.inbox,
});

const mapDispatchToProps = {
	setUserInfo,
	showAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePageV2);
